
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M26.642 4H5.324C4.593 4 4 4.594 4 5.326v21.348C4 27.406 4.593 28 5.324 28h11.48v-9.263H13.67v-3.65h3.115V12.42c0-3.103 1.888-4.792 4.65-4.792.94.003 1.877.057 2.81.16v3.238h-1.91c-1.5 0-1.79.712-1.79 1.76v2.316h3.594l-.466 3.634h-3.129V28h6.097c.732 0 1.325-.594 1.325-1.326V5.326c0-.732-.593-1.326-1.325-1.326z"}})])
      }
    
      }
    